import DOMPurify from "dompurify";
import { convert } from "html-to-text";
import twitterText from "twitter-text";
export function plainContent(html) {
  return convert(DOMPurify.sanitize(html || ""), { wordwrap: false, selectors: [{ selector: "a", options: { ignoreHref: true } }, { selector: "h1", options: { uppercase: false } }, { selector: "h2", options: { uppercase: false } }, { selector: "h3", options: { uppercase: false } }] }).trim();
}
export function publicationCaption(post) {
  const tags = (post.tags || "").split(/[,\s]+/).filter(Boolean).map(tag => `#${tag.replace(/^#/, "").replace(/[^\p{L}\p{N}_]/gu, "")}`).filter(tag => tag !== "#").join(" ");
  const title = ["twitter", "instagram"].includes(post.platform) ? null : post.title;
  return [title, post.content_html ? plainContent(post.content_html) : post.content, post.destination_url, tags].filter(Boolean).join("\n\n");
}
export const xCount = post => twitterText.parseTweet(publicationCaption({ ...post, platform: "twitter" }));
export function toRichContent(post) {
  if (post.content_html) return DOMPurify.sanitize(post.content_html);
  const element = document.createElement("div"); element.textContent = post.content || "";
  return element.innerHTML.replace(/\r?\n/g, "<br>");
}
export function publicationGroups(rows) {
  const groups = new Map();
  for (const item of rows) {
    const key = `${item.batch_id || `single-${item.id}`}|${item.scheduled_at || "unscheduled"}`;
    if (!groups.has(key)) groups.set(key, { key, items: [], title: item.title, scheduled_at: item.scheduled_at });
    groups.get(key).items.push(item);
  }
  return [...groups.values()];
}
